import React from "react";
import { Zap } from "lucide-react";

const fmtNum = (v) => Number(v || 0).toLocaleString("pt-BR");
const fmtMoney = (v) =>
  `R$ ${Number(v || 0).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;

// Quanto das vendas entrou sozinho, sem ninguém do salão digitar: Mesa QR,
// Totem e o Cardápio Digital. Pedido importado de outro sistema fica fora da
// conta, porque nasceu em outro PDV e não é venda que o Núcleo automatizaria.
export default function CardAutomacao({ automacao }) {
  const pct = Math.round(automacao?.pctPedidos || 0);
  const temBase = (automacao?.basePedidos || 0) > 0;

  return (
    <div
      className="rounded-xl border border-emerald-500/30 bg-gradient-to-br from-emerald-500/10 to-emerald-500/[0.02] px-3 py-3"
      data-e2e="card-automacao"
    >
      <div className="flex items-center gap-1.5 mb-2">
        <Zap className="w-3.5 h-3.5 text-emerald-500" />
        <span className="text-[11px] font-bold uppercase tracking-wider text-emerald-600 dark:text-emerald-400">
          Vendas no automático
        </span>
      </div>
      <div className="flex items-end gap-2">
        <span className="text-3xl font-black leading-none text-emerald-600 dark:text-emerald-400">
          {temBase ? `${pct}%` : "—"}
        </span>
        <span className="text-[11px] text-muted-foreground pb-0.5">dos pedidos</span>
      </div>
      <div className="h-1.5 rounded-full bg-emerald-500/15 overflow-hidden mt-2">
        <div className="h-full rounded-full bg-emerald-500" style={{ width: `${Math.min(pct, 100)}%` }} />
      </div>
      <p className="text-[11px] text-muted-foreground mt-2 leading-snug">
        {temBase ? (
          <>
            <strong className="text-foreground">{fmtNum(automacao.pedidos)}</strong> pedidos e{" "}
            <strong className="text-foreground">{fmtMoney(automacao.receita)}</strong> entraram sozinhos
            pelo Mesa QR, Totem e Cardápio Digital, sem ninguém digitar.
          </>
        ) : (
          "Ligue o Cardápio Digital, o Totem ou o Mesa QR para o cliente pedir sozinho."
        )}
      </p>
    </div>
  );
}
